import VueAos from "vue-aos";
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "speSection",
  components: { VueAos,
    Carousel,
    Slide },
};
